import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { ButtonTypeEnum } from '../../../../../ui/buttons/button/button-type.enum';

@Component({
  selector: 'app-vb-payment-change-accordion',
  templateUrl: './vb-payment-change-accordion.component.html',
  styleUrls: ['./vb-payment-change-accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentChangeAccordionComponent implements OnChanges {
  @Input() disableUpdateButton: boolean = false;
  @Input() showUpdateButton: boolean = true;

  @Output() updatePayments = new EventEmitter<void>();

  public isCollapsed = true;
  public chevronSrc: string = 'assets/icons/white/Chevron-right.svg';

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.disableUpdateButton) {
      this.chevronSrc = this.disableUpdateButton
        ? 'assets/icons/grey/Chevron Right.svg'
        : 'assets/icons/white/Chevron-right.svg';
    }
  }
  protected readonly ButtonTypeEnum = ButtonTypeEnum;
}
